import { render, staticRenderFns } from "./MessageTemplateEvent.vue?vue&type=template&id=3e1277ec&scoped=true&"
import script from "./MessageTemplateEvent.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateEvent.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateEvent.vue?vue&type=style&index=0&id=3e1277ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1277ec",
  null
  
)

export default component.exports